import { createFileRoute } from "@tanstack/react-router";
import { AdminLoginForm } from "@/features/admin/auth/components/AdminLoginForm";
import { AuthShell } from "@/shared/layout/AuthShell";
import { useT } from "@/shared/i18n";

export const Route = createFileRoute("/admin/login")({
  component: AdminLoginPage,
});

function AdminLoginPage() {
  const t = useT();
  return (
    <AuthShell title={t("admin.auth.title")} subtitle={t("admin.auth.subtitle")}>
      <AdminLoginForm />
    </AuthShell>
  );
}
